import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { swalSuccess, swalError } from '../utils/alert';
import { toLocalDateInput } from '@sf/shared';

function PayInvoiceModal({ show, onClose, invoice, onPaymentSuccess }) {
    const [paymentDate, setPaymentDate] = useState(toLocalDateInput(new Date()));
    const [bankAccountId, setBankAccountId] = useState('');
    const [banks, setBanks] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (show) {
            api.get('/banks')
                .then(response => {
                    setBanks(response.data);
                    // Pre-select the first bank account if available
                    if (response.data.length > 0) {
                        setBankAccountId(response.data[0].id);
                    }
                })
                .catch(error => console.error('Error fetching banks:', error));
        }
    }, [show]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        const paymentData = {
            paid_amount: invoice.total_amount,
            payment_date: paymentDate,
            bank_account_id: bankAccountId,
            is_partial: false, // For now, we only support full payment
        };

        try {
            const response = await api.post(`/invoices/${invoice.id}/pay`, paymentData);
            swalSuccess('Fatura paga com sucesso!');
            onPaymentSuccess(response.data); // Pass updated invoice data back to parent
            onClose();
        } catch (error) {
            console.error('Error paying invoice:', error);
            swalError('Falha ao pagar a fatura.');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!show) {
        return null;
    }

    return (
        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Pagar Fatura #{invoice.id}</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <p><strong>Valor a Pagar:</strong> {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(invoice.total_amount)}</p>
                            <div className="mb-3">
                                <label htmlFor="payment_date" className="form-label">Data de Pagamento</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="payment_date"
                                    value={paymentDate}
                                    onChange={(e) => setPaymentDate(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="bank_account_id" className="form-label">Pagar com a Conta</label>
                                <select
                                    className="form-control"
                                    id="bank_account_id"
                                    value={bankAccountId}
                                    onChange={(e) => setBankAccountId(e.target.value)}
                                    required
                                >
                                    <option value="" disabled>Selecione uma conta</option>
                                    {banks.map(bank => (
                                        <option key={bank.id} value={bank.id}>{bank.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                    {isSubmitting ? 'Confirmando...' : 'Confirmar Pagamento'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PayInvoiceModal;
